import { t } from "@lingui/macro";
import { UrlDto } from "@reactive-resume/dto";
import { useMutation } from "@tanstack/react-query";

import { toast } from "@/client/hooks/use-toast";
import { axios } from "@/client/libs/axios";
import { useAuthStore } from "@/client/stores/auth";
import { trackEvent } from "@/client/utils/analytics";

let dlid: any; //= window.location.pathname.slice(1);
// console.log("token",dlid,urlSearchParams)

export const printResume = async (data: { id: string }) => {
  if (dlid) {
    // alert(dlid)
    console.log("Inside print tsx for token");
    // sessionStorage.setItem("token", dlid);
  } else {
    dlid = sessionStorage.getItem("token");
  }
  console.log(window.location.host + `/resume/print/${dlid}`);
  trackEvent({
    userType: "youth",
    apiName: "printResume",
    userId: useAuthStore.getState().user?.id,
    success: true,
    resourceId: data.id,
  });
  window.location.href =
    window.location.protocol + "//" + window.location.host + `/api/resume/print/${dlid}`;
  return "";
  // const response:any = await axios.get<Blob>(`/resume/print/${dlid}`);
  // console.log(response)
  // const href = URL.createObjectURL(response.data);
  // window.location.href = window.location.host+`/resume/print/${dlid}`
  //   // create "a" HTML element with href to file & click
  //   const link = document.createElement('a');
  //   link.href = href;
  //   link.setAttribute('download', 'file.pdf'); //or any other extension
  //   document.body.appendChild(link);
  //   link.click();

  //   // clean up "a" element & remove ObjectURL
  //   document.body.removeChild(link);
  //   URL.revokeObjectURL(href);
};

export const usePrintResume = () => {
  const {
    error,
    isPending: loading,
    mutateAsync: printResumeFn,
  } = useMutation({
    mutationFn: printResume,
    onError: (error) => {
      const message = error?.message;

      toast({
        variant: "error",
        title: t`Oops, the server returned an error.`,
        description: message,
      });
    },
  });

  return { printResume: printResumeFn, loading, error };
};
